<template lang="pug">
  .course-points-shop-info(
  )
    p.course-points-shop-info__text(
      @click="togglePopup"
    )
      span {{text}}
      Icon.course-points-shop-info__icon(
        :icon="icon"
      )
    SlideUpDown.course-points-shop-info-popup-wrap(:active="isOpen")
      .course-points-shop-info-popup
        Icon.course-points-shop-info-popup__close(
          icon="side-close"
          @click="closePopup"
        )
        p.course-points-shop-info-popup__title {{title}}
        p.course-points-shop-info-popup__text
          slot
            | При покупке промокода за бонусы необходимо перейти на
            a(href="https://likecentre.ru/toolbox-lms-shop")
              | https://likecentre.ru/toolbox-lms-shop
            | , выберите нужный продукт и введите свой промокод.

</template>

<script>
import SlideUpDown from 'vue-slide-up-down';

export default {
  components: { SlideUpDown },
  props: {
    text: {
      type: String,
      default: 'Как использовать промокод?'
    },
    title: {
      type: String,
      default: 'Как использовать промокод?'
    },
    icon: {
      type: String,
      default: 'ui-question'
    }
  },
  data: () => ({
    isOpen: false
  }),
  methods: {
    togglePopup() {
      this.isOpen = !this.isOpen;
    },
    closePopup() {
      this.isOpen = false;
    }
  }
};
</script>
